'use client';

import { OrderActionExplanation } from '@drift-labs/sdk';
import { matchEnum } from '@drift/common';
import type { ParentOrderInfo } from 'src/@types/historyTables';
import { lastOrderStatusToNormalEng } from 'src/utils/strings';

interface StatusCellProps {
	order: ParentOrderInfo;
}

export function StatusCell({ order }: StatusCellProps) {
	const { lastActionStatus, lastActionExplanation } = order;
	const orderStatus = lastOrderStatusToNormalEng(lastActionStatus);

	const isLiquidationOrder = matchEnum(
		lastActionExplanation,
		OrderActionExplanation.LIQUIDATION
	);
	const isAutoDerisk = matchEnum(
		lastActionExplanation,
		OrderActionExplanation.DERISK_LP
	);

	return (
		<div className="flex flex-col">
			<span>{orderStatus}</span>
			{isLiquidationOrder && (
				<span className="typo-t5 text-text-secondary">(Liquidation)</span>
			)}
			{isAutoDerisk && (
				<span className="typo-t5 text-text-secondary">(BAL Auto-Derisk)</span>
			)}
		</div>
	);
}
